import React from 'react';
import { clsx } from 'clsx';
import { Col, Row } from 'antd';
import { makeStyles } from '@mui/styles';

import { CreditRisk } from '@types';
import { moneyFormatter } from '@utils';
import { TablePastCycleRow } from '@network';


interface Props {
  risk: CreditRisk;
  noTitle?: boolean;
}

export const RiskVariables = ({ risk, noTitle }: Props) => {
  const cls = useStyles();
  const { tablePastCycle, tableProjectedCycle } = risk;

  const getValue = (row: TablePastCycleRow | null): string => {
    if (!row) return '';
    if (row.format === 'number' || row.format === 'text') {
      return row.value?.toString() || '';
    }
    return typeof row.value === 'number' && row.format === 'money'
      ? moneyFormatter.format(row.value || 0).toString()
      : `${row.value || 0}%`;
  };

  return (
    <div className="income-verification-wg">
      {(tablePastCycle?.rows || tableProjectedCycle?.rows) && !noTitle
        ? <div className={cls.title}>Income Verification</div>
        : null}
      <Row gutter={[20, 20]}>
        <Col md={12} sm={24}>
          {tablePastCycle?.rows && Array.isArray(tablePastCycle.rows) ? (
            <div className={cls.wrap}>
              <div className={clsx(cls.header, cls.headerTop)}>Past Cycle</div>
              {tablePastCycle.rows.map((row, idx) => (
                <div key={idx} className={clsx(
                  cls.row,
                  'row',
                  typeof row.separator === 'string' && cls.rowSeparator,
                )}>
                  {typeof row.separator === 'string' ? (
                    <div className={clsx(cls.row, 'row')}>
                      <div className={clsx('col', cls.col, cls.colSeparator)}>
                        {row.separator}
                      </div>
                    </div>
                  ) : null}
                  <div className={clsx('col', cls.col)}>{row.title}</div>
                  <div className={clsx('col', cls.col, cls.colValue)}>
                    {getValue(row)}
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </Col>
        <Col md={12} sm={24}>
          {tableProjectedCycle?.rows && Array.isArray(tableProjectedCycle.rows) ? (
            <div className={cls.wrap}>
              <div className={clsx(cls.header, cls.headerTop)}>Projected Cycle</div>
              {tableProjectedCycle.rows.map((row, idx) => (
                <div key={idx} className={clsx(
                  cls.row,
                  'row',
                  typeof row.separator === 'string' && cls.rowSeparator,
                )}>
                  {typeof row.separator === 'string' ? (
                    <div className={clsx(cls.row, 'row')}>
                      <div className={clsx('col', cls.col, cls.colSeparator)}>
                        {row.separator}
                      </div>
                    </div>
                  ) : null}
                  <div className={clsx('col', cls.col)}>{row.title}</div>
                  <div className={clsx('col', cls.col, cls.colValue)}>
                    {getValue(row)}
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

const useStyles = makeStyles({
  title: {
    margin: '25px 0 5px',
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 600,
    color: 'var(--title-color)',
  },
  wrap: {
    border: '1px solid var(--primary-color)',
    borderRadius: 5,
    overflow: 'hidden',
    backgroundColor: 'var(--foreground-color)',
  },
  header: {},
  headerTop: {
    minHeight: 34,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--foreground-color)',
    fontSize: 12,
    fontWeight: 500,
    backgroundColor: 'var(--primary-color)',
  },
  row: {
    borderTop: '1px solid var(--primary-color)',
    display: 'flex',
    minHeight: 34,
  },
  rowSeparator: {
    position: 'relative',
    paddingTop: 34,
  },
  col: {
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 50%',
    maxWidth: '50%',
    color: 'var(--primary-color)',
    fontSize: 12,
    fontWeight: 400,
    padding: '3px 8px',
  },
  colSeparator: {
    height: 34,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    justifyContent: 'center',
    flex: '0 0 100%',
    maxWidth: '100%',
    color: 'var(--foreground-color)',
    fontSize: 12,
    fontWeight: 400,
    backgroundColor: 'var(--primary-color)',
  },
  colValue: {
    borderLeft: '1px solid var(--primary-color)',
    backgroundColor: 'var(--background-color)',
    color: 'var(--text-color)',
  },
});
